import React from "react";
import DownloadFormPage from "../components/downloads/DownloadFormPage";

const DownloadEdit = () => <DownloadFormPage mode="edit" />;

export default DownloadEdit;
